// 计算今日涨跌幅（平均值 = 各项涨跌幅求和 / 数量）
// - 输入为后端返回的字符串（可能位数很长，带正负号）
// - 内部用改良求和算法（Kahan）降低浮点误差
// - 显示时最多两位小数，不补 0，例如 20.8%、-3%、0%

/**
 * 计算股票涨跌幅
 * @param currentPrice 当前价格
 * @param previousClose 前一日收盘价
 * @returns 涨跌幅百分比
 */
const calculateStockChange = (
  currentPrice: number | undefined,
  previousClose: number | undefined,
): number | undefined => {
  // 验证逻辑
  if (
    currentPrice == null ||
    previousClose == null ||
    isNaN(currentPrice) ||
    isNaN(previousClose) ||
    previousClose === 0
  ) {
    return undefined;
  }

  // 计算涨跌幅百分比
  return ((currentPrice - previousClose) / previousClose) * 100;
};

type TodayGainResult = { text: string; isUp: boolean } | undefined;
export const computeTodayGain = (list: any): TodayGainResult => {
  if (!Array.isArray(list) || list.length === 0) {
    return undefined;
  }
  let sum = 0;
  let c = 0; // Kahan 补偿
  let count = 0;
  for (const item of list) {
    // 根据资产类型区分计算方法
    const assetType = item?.type || "TOKEN";
    let n: number | undefined;

    if (assetType === "STOCK") {
      // 股票：计算涨跌幅
      const currentPrice = item?.trading_data?.current_price;
      const previousClose = item?.trading_data?.previous_close;
      n = calculateStockChange(currentPrice, previousClose);

      if (n === undefined) {
        continue;
      }
    } else {
      // Token：使用 price_change_24h
      const raw = item?.trade?.price_change_24h;
      if (raw === undefined || raw === null) {
        continue;
      }
      n = typeof raw === "number" ? raw : parseFloat(String(raw));
    }

    if (!Number.isFinite(n)) {
      continue;
    }
    // Kahan summation
    const y = n - c;
    const t = sum + y;
    c = t - sum - y;
    sum = t;
    count += 1;
  }
  if (count === 0) {
    return undefined;
  }
  const avg = sum / count;
  // 先保留更高精度，再格式化到最多两位展示
  const precise = Number(avg.toFixed(6));
  const formatted = new Intl.NumberFormat(undefined, {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(precise);
  return { text: `${formatted}%`, isUp: precise >= 0 };
};
